var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"text-center text-lg"},[(_vm.content)?_c('i',{staticClass:"fas fa-check check-green"}):_c('i',{staticClass:"fas fa-times times-red"})])
}
var staticRenderFns = []

export { render, staticRenderFns }